import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Labelbox, Table, Button } from "../../components";
import { Grid, Paper, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { CLIENT_REFERRAL_ACTION } from "../../redux/action";
import { getClientById } from "../../redux/action/clientAction";
import ValidationLibrary from "../../utils/validationfunction";
import { Toaster, dateTimeFormatter } from "../../utils/common";
// import FilterListOutlinedIcon from "@material-ui/icons/FilterListOutlined";
import "./referralProgram.scss";

const useStyes = makeStyles((theme) => ({
  margin: {
    [theme.breakpoints.up("md")]: {
      marginTop: "1rem",
    },
  },
}));

const ReferralProgram = () => {
  const classes = useStyes();
  const dispatch = useDispatch();
  const defaultCreateState = {
    referral_name: {
      labelname: "Name",
      value: "",
      validation: [{ name: "required" }],
      error: null,
      errmsg: null,
    },
    referral_email: {
      labelname: "Email Address",
      value: "",
      validation: [{ name: "required" }, { name: "emailNew" }],
      error: null,
      errmsg: null,
    },
    referral_phone: {
      labelname: "Phone",
      value: "",
      validation: [{ name: "required" }, { name: "mobile" }],
      error: null,
      errmsg: null,
    },
  };


  const [fieldConfiguration, setFieldConfiguration] =
    useState(defaultCreateState);
  const [submitting, setSubmitting] = useState(false);
  const { getAllReferrals } = useSelector((state) => state.referral);

  const userRole = localStorage.getItem("user_role");
  const isClient = userRole === "client";
  const clientId = localStorage.getItem("user_id");

  const readReferrerProfile = useCallback(() => {
    try {
      return JSON.parse(localStorage.getItem("USER_DATA") || "{}");
    } catch {
      return {};
    }
  }, []);

  const resolveManagerId = useCallback(async () => {
    const profile = readReferrerProfile();
    if (profile?.sales) return String(profile.sales);

    if (!clientId) return null;
    try {
      const client = await dispatch(getClientById(clientId)).unwrap();
      return client?.sales ? String(client.sales) : null;
    } catch {
      return null;
    }
  }, [clientId, dispatch, readReferrerProfile]);

  const referralsTableData = useMemo(() => {
    return getAllReferrals.map((data) => {
      const {
        referral_name,
        referral_email,
        referral_phone,
        createdAt,
        bonus,
        referred_name,
        referred_email,
      } = data;
      
      const baseData = {
        referral_name,
        referral_email,
        referral_phone,
        createdAt: dateTimeFormatter(createdAt),
      };

      if (isClient) {
        // Client view: all fields including referred_by, no bonus
        return {
          referral_name,
          referral_email,
          referral_phone,
          createdAt: dateTimeFormatter(createdAt),
          referred_name: referred_name || "-",
          referred_email: referred_email || "-",
        };
      } else {
        // Admin/other roles view: includes bonus, no referred_by
        return {
          referral_name,
          referral_email,
          referral_phone,
          bonus: bonus ? `$${bonus}` : "----",
          createdAt: dateTimeFormatter(createdAt),
        };
      }
    });
  }, [getAllReferrals, isClient]);

  useEffect(() => {
    dispatch(CLIENT_REFERRAL_ACTION.getAllReferral());
  }, []);

  const handleChange = (value, fieldKey) => {
    const errorcheck = ValidationLibrary.checkValidation(
      value,
      fieldConfiguration[fieldKey].validation
    );
    fieldConfiguration[fieldKey].value = value;
    fieldConfiguration[fieldKey].error = !errorcheck.state;
    fieldConfiguration[fieldKey].errmsg = errorcheck.msg;
    setFieldConfiguration({ ...fieldConfiguration });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const errorList = Object.keys(fieldConfiguration).filter((fieldKey) => {
        const errorcheck = ValidationLibrary.checkValidation(
          fieldConfiguration[fieldKey].value,
          fieldConfiguration[fieldKey].validation
        );
        fieldConfiguration[fieldKey].error = !errorcheck.state;
        fieldConfiguration[fieldKey].errmsg = errorcheck.msg;
        return !errorcheck.state;
      });
      setFieldConfiguration({ ...fieldConfiguration });
      if (errorList.length) return;

      setSubmitting(true);
      const referrerProfile = readReferrerProfile();
      const managerId = isClient ? await resolveManagerId() : null;

      const payload = {
        client_id: clientId,
        referral_name: fieldConfiguration.referral_name.value,
        referral_email: fieldConfiguration.referral_email.value,
        referral_phone: fieldConfiguration.referral_phone.value,
        referred_name: `${localStorage.getItem("first_name") || ""} ${localStorage.getItem("last_name") || ""}`.trim(),
        referred_email: localStorage.getItem("email"),
      };

      if (isClient) {
        payload.send_referral_email = true;
        if (managerId) payload.manager_id = managerId;
      }

      const result = await CLIENT_REFERRAL_ACTION.insertClientReferral(payload);
      if (result?.success) {
        dispatch(CLIENT_REFERRAL_ACTION.getAllReferral());
        setFieldConfiguration(defaultCreateState);
        Toaster.success(
          isClient
            ? "Referral submitted. An email has been sent to your friend with your manager copied."
            : "Referral added successfully",
        );
      } else {
        Toaster.error(result?.message || "Failed to submit referral");
      }
    } catch (error) {
      console.error(error);
      Toaster.error("Failed to submit referral");
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className="referral-page-wrapper" style={{ paddingTop: "1.8rem" }}>
      <Grid container className="referral-page-content">
        {isClient && (
          <Grid item xs={12} className="referral-client-stack">
            <Paper className="payment-notes">
              <span>
                Refer a friend and earn a $25 credit on your bill.
              </span>
            </Paper>
            <Grid
              container
              spacing={3}
              alignItems="center"
              className="referral-client-form"
            >
              {Object.keys(fieldConfiguration).map((data, index) => (
                <Grid item xs={12} md={4} sm={6} lg={3} key={`data${index}`}>
                  <Labelbox
                    type={fieldConfiguration[data].type || "text"}
                    labelname={fieldConfiguration[data].labelname}
                    changeData={(e) => handleChange(e, data)}
                    disabled={fieldConfiguration[data].disabled}
                    value={fieldConfiguration[data].value}
                    error={fieldConfiguration[data].error}
                    errmsg={fieldConfiguration[data].errmsg}
                  />
                </Grid>
              ))}

              <Grid
                item
                xs={12}
                sm={12}
                md={3}
                lg={3}
                className={classes.margin}
              >
                <Button
                  text={submitting ? "Submitting..." : "Submit"}
                  large
                  handleClick={handleSubmit}
                  disable={submitting}
                />
              </Grid>
            </Grid>
          </Grid>
        )}
        <Grid item xs={12}>
          <div
            className={`referral-panel ${
              !isClient ? "referral-admin-view" : ""
            }`}
          >
            <div className="referral-panel-heading">
              <h3 className="referral-panel-title">Program Info</h3>
              {/* <div className="referral-panel-tools">
                  <IconButton className="referral-icon-btn" aria-label="Filter">
                    <FilterListOutlinedIcon />
                  </IconButton>
                </div> */}
            </div>
            <Table
              variant="small"
              title=""
              header={
                isClient
                  ? [
                      { id: "1", label: "Name" },
                      { id: "2", label: "Email ID" },
                      { id: "3", label: "Phone" },
                      { id: "4", label: "Created on" },
                      { id: "5", label: "Referred by (Name)" },
                      { id: "6", label: "Referred by (Email)" },
                    ]
                  : [
                      { id: "1", label: "Name" },
                      { id: "2", label: "Email ID" },
                      { id: "3", label: "Phone" },
                      { id: "4", label: "Bonus" },
                      { id: "5", label: "Created On" },
                    ]
              }
              data={referralsTableData}
              aligncss="dashboard-table"
            />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ReferralProgram;

